export const SERVER_URL = 'https://music-be.thisisringo.com';

